import React, { useState } from 'react'
import 'react-calendar/dist/Calendar.css'
import { Link } from 'react-router-dom'
import authService from '../Components/Login/auth.service'
import padrao from '../Components/profile.png'
import '../styles/components/profiledireita.css'

function ProfileDireita() {
  var user = authService.getCurrentUser()
  const [image, setImage] = useState(user[0].pesFoto)
  var img = new Image()
  img.src = user[0].pesFoto
  // Se foi possível carregar a imagem
  img.onload = () => {
    setImage(user[0].pesFoto)
  }
  // Caso não seja possível
  img.onerror = () => {
    setImage(padrao)
  }
  return (
    <div className="cxProfile">
      <h6 className="titleProfile1">Seja Muito Bem-vindo,</h6>
      <h6 className="titleProfile2">{user[0].pesNome}</h6>
      <div className="alignFotoProfile">
        {image ? (
          <img className="logo1" src={image} alt="perfil" />
        ) : (
          <img src="./perfil.png" alt="Profile" className="logo1" />
        )}
        <Link to="/ViewProfile">
          <button
            className="profile-profileEditor"
            // onClick={() => handleToggleComplete(user[0])}
          >
            Ver perfil
          </button>
        </Link>
      </div>
    </div>
  )
}

export default ProfileDireita
